module.exports = "<span><strong *ngIf=\"field\">{{field}}:</strong> {{isDate ? (value | date: \"MM/dd/yyyy h:mma\") : value}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/display-text/display-text.component.html
// module id = 294
// module chunks = 0 1